import {
  show_run_label_default
} from "./chunk-CCT73ESN.js";

// src/blocks/show-run-label/index.ts
var show_run_label_default2 = show_run_label_default;

export {
  show_run_label_default2 as show_run_label_default
};
